import Vue from 'vue'
import Vuex from 'vuex'
import {httpRoom} from "@/api/http";
const {logInfo} = require('@/modules/Logger.js')

const {aircraftConfig} = require('../config')

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        sphereTexture: null,
        cockpit: {
            loading: false,
            aircraftName: '',
            tourGroups: [],
            room: {},
            procedures: [],
            spots: [],
            loadedTextures: {
                sphere: null
            }
        },
        user: "",
        completed_procedures: [],
        currentProcedure: null,
    },
    getters: {
        cockpitLoading(state) {
            return state.cockpit.loading;
        },
    },
    mutations: {
        // SET_AIRCRAFT(state, name) {
        //     state.cockpit.aircraftName = name;
        // },
        SET_CURRENT_PROCEDURE(state, procedure) {
            state.currentProcedure = procedure
        },
        SET_LOADING(state, status) {
            state.cockpit.loading = status;
        },
        SET_USER(state, name) {
            state.user = name;
            localStorage.setItem('username', name)
        },
        INIT_COCKPIT(state, {room, spots, tourGroups, tours}) {
            logInfo('start init cockpit from web config')
            state.sphereTexture = room.sphere_texture
            state.cockpit.room = room
            state.cockpit.tourGroups = tourGroups
            state.cockpit.spots = spots.map((spot: any) => {
                spot.vec = spot.coordinates.split(',').map((el: string) => Number(el))
                spot.name = spot.title;
                spot.panel = spot.group.title;
                return spot;
            })
            state.cockpit.procedures = tours.map((tour: any) => {
                tour.name = tour.title; // legacy map
                return tour;
            })
            state.cockpit.aircraftName = room.title
            logInfo('init cockpit from config done')
            aircraftConfig.selectAircraft(state.cockpit);
            logInfo('aircraft selected')
        },
        SAVE_LOADED_TEXTURE(state, textureInfo: { key: string, texture: any }) {
            (state.cockpit.loadedTextures as any)[textureInfo.key] = textureInfo.texture;
        },
        RESET_USER(state) {
            state.user = ''
            state.completed_procedures = []
            localStorage.removeItem('username')
        },
        ADD_COMPLETED_PROCEDURE(state, {aircraft, procedure}) {
            // @ts-ignore
            state.completed_procedures = [...state.completed_procedures, {aircraft: aircraft, procedure: procedure}];
        }

    },
    actions: {
        async loadCockpitFromAPI({commit}, roomId) {
            logInfo('loadCockpitFromAPI...')
            const cockpitData = await httpRoom(roomId);
            logInfo('loadCockpitFromAPI done...')
            commit('INIT_COCKPIT', cockpitData)
        },
        getUsernameFromStorage({commit}) {
            const username = localStorage.getItem('username');
            if (username) {
                commit('SET_USER', username)
            }
        },
        saveUser({commit}, name) {
            commit('SET_USER', name)
        },
        logOut({commit}, name) {
            commit('RESET_USER')
        },
        addCompletedProcedure({commit}, {aircraft, procedure}) {
            commit('ADD_COMPLETED_PROCEDURE', {aircraft, procedure})
        }
    },
    modules: {}
})


